import EditPayRateHistoryEntryForm from './EditPayRateHistoryEntryForm';

export default EditPayRateHistoryEntryForm;
